<template>

<com-content :loading="is.loading" :text="text" :empty="!reviews.length" :hideEmpty="true">

    <div class="reviews-empty" v-if="!reviews.length">

        <p>{{ page.reviews_empty }}</p>

        <app-button :to="{name: 'Business/Reviews/Write'}" theme="yellow" :text="page.reviews_button" v-if="!isSessionBusiness" />

    </div>

	<template v-if="is.autoload">

    <app-review :text="text" :review="autoload" viewAs="public" />

	<app-group :row="true" :center="true">

		<app-button text="View all reviews" v-on:click="onAutoloseClose" v-if="total > 1" />

	</app-group>

	</template>

	<template v-if="!is.autoload">

    <app-review :text="text" v-for="review in reviews" :key="review.id" :review="review" viewAs="public" />

    <app-pagination v-if="reviews.length" :pages="pages" :current="current" v-on:change="onPageChange" />

	</template>

</com-content>

</template>

<script>

import comContent from './common/Content'

export default {

    components: {
        'com-content': comContent
    },

    data: function() {

        return {
            is: {
				loading: false,
				autoload: false
			},
			autoload: false,
            reviews: [],
            total: 0,
            pages: 1,
            current: 1
        }

    },

    computed: {

        text: function() {

            return {
                empty: this.page.reviews_empty,
                read: {
                    created_prefix: this.page.reviews_read_created_prefix,
                    pending_label: this.page.reviews_read_status_pending_label,
                    pending_tooltip: this.page.reviews_read_status_pending_tooltip,
                    recommendation_title: this.page.reviews_read_recommendation_title,
                    recommendation_yes: this.page.reviews_read_recommendation_yes,
                    recommendation_no: this.page.reviews_read_recommendation_no,
                    date_title: this.page.reviews_read_date_title,
					time_title: this.page.reviews_read_time_title,
                    contact_title: this.page.reviews_read_contact_title
                },
                report: {
                    title: this.page.reviews_report_title,
                    description: this.page.reviews_report_description,
                    text_label: this.page.reviews_report_text_label,
                    text_placeholder: this.page.reviews_report_text_placeholder,
                    reason_label: this.page.reviews_report_reason_label,
                    reason_placeholder: this.page.reviews_report_reason_placeholder,
                    message_success: this.page.reviews_report_message_success,
                    message_error: this.page.reviews_report_message_error,
                    button_save: this.page.reviews_report_button_save,
                    button_cancel: this.page.reviews_report_button_cancel
                }
            }

        }

    },

    created: function() {

        this.fetch()

    },

    methods: {

        onPageChange: function(page) {

            this.current = page
            this.fetch()

		},
		
		onAutoloseClose: function() {

			this.is.autoload = false

		},

        fetch: function() {

            this.is.loading = true

            this.$api.request('business/reviews', {
                slug: this.page.business.slug,
				page: this.current,
				autoload: this.$route.params.hash
            }).then(function(json) {

                this.reviews = json.items
                this.pages = json.pages
                this.current = json.page 
                this.total = json.total

				this.is.loading = false
				
				if (this.$route.params.hash) {

					this.is.autoload = true

					this.autoload = json.autoload

					this.$router.replace({
						name: 'Business/Reviews'
					})

				}

            }.bind(this))

        }

    }

}

</script>

<style scoped>

.reviews-empty {
    font-size: 20px;
    height: 240px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    color: var(--color-grey);
}

.is-mobile .reviews-empty {
	height: auto;
	padding: 20px;
	font-size: 14px;
	line-height: 18px;;
}

.reviews-empty p {
    margin-bottom: 20px;
}

</style>